/*
 * @description:
 * @author: Jason Wong
 * @since: 2022-05-23 14:04:31
 */
import { consoleIfDevelopment } from "../../configs/env";
import { isBlank } from "../../utils/String";
import { download } from "@/utils/downloadHelper";

export const MESSAGE_SOURCE = {
    system: 0,
    self: 1,
};

export const NOTICE_MODULES = {
  
}

const jumpTagDealers = new Map();
const retryDownloadDealers = new Map();

export function addJumpTagDealer(tagName, jumpFunc) {
    jumpTagDealers.set(tagName, jumpFunc);
}

export function addRetryDownloadDealer(handler, downloadFunc) {
    retryDownloadDealers.set(handler, downloadFunc);
}

class JumpTagInfo {
    constructor() {
        this.router = null;
        this.text = null;
        this.params = new Map();
    }
}

class RetryDownloadInfo {
    constructor() {
        this.handler = null;
        this.fileId = null;
        this.fileType = null;
    }
}

export function isJump(ele) {
    return !!ele && ele.tagName === "JUMP";
}

export function isPath(ele) {
    return !!ele && ele.tagName === "JUMP" && ele.attributes && ele.attributes.href && ele.attributes.href.value;
}

export function isRetryDownload(ele) {
    return !!ele && ele.tagName === "RETRY-DOWNLOAD";
}

const ATTR_DATA_SYMBOL = "data-";
const ROUTER_SYMBOL = "router";
export function dealJump(jumpEle, router) {
    console.log("#-# deal jump");
    if (!jumpEle) return;

    const tagInfo = new JumpTagInfo();
    tagInfo.text = jumpEle.innerText;
    for (const attr of Array.prototype.slice.call(jumpEle.attributes, 0)) {
        let key = attr.name;
        if (key.startsWith(ATTR_DATA_SYMBOL) && key.length > ATTR_DATA_SYMBOL.length) {
            key = key.substring(ATTR_DATA_SYMBOL.length);
        }
        const value = attr.value;

        if (key === ROUTER_SYMBOL) {
            tagInfo.router = value;
        } else {
            tagInfo.params.set(key, value);
        }
    }

    const dealer = jumpTagDealers.get(tagInfo.router || "unknow");
    if (!dealer) {
        consoleIfDevelopment(`Failed to get a suitable dealer for <jump>,whose router is ${tagInfo.router}`);
    } else {
        dealer.call(null, router, tagInfo);
    }
}

export function dealPath(ele){
    if (!ele) return;
    if(ele.attributes.href.value){
        download(ele.attributes.href.value);
    }
}

export function downloadFile(ele){
    if (!ele) return;
    if(ele.attributes.href.value){
        download(ele.attributes.href.value);
    }
}

export function dealRetryDownload(ele) {
    if (!ele) return;

    const downloadInfo = new RetryDownloadInfo();
    for (const attr of Array.prototype.slice.call(ele.attributes, 0)) {
        let key = attr.name;
        if (key.startsWith(ATTR_DATA_SYMBOL) && key.length > ATTR_DATA_SYMBOL.length) {
            key = key.substring(ATTR_DATA_SYMBOL.length);
        }
        const value = attr.value;

        if (key === "handler") {
            downloadInfo.handler = value;
        } else if (key === "file-id") {
            downloadInfo.fileId = value;
        } else if (key === "file-type") {
            downloadInfo.fileType = value;
        }
    }

    const dealer = retryDownloadDealers.get(downloadInfo.handler);
    if (!dealer) {
        consoleIfDevelopment(`Failed to get a suitable dealer for <retry-download>, whose handler is ${downloadInfo.handler}`);
    } else {
        dealer.call(null, downloadInfo);
    }
}

export class RedirectRouter {
    constructor(router, currentRouteName) {
        this._router = router;
        this.currentRouteName = currentRouteName;
    }

    push(target) {
        if (!target) return;

        if (isBlank(this.currentRouteName) || target.name === this.currentRouteName) {
            this._router.replace({
                name: "noticeRedirector",
                params: {
                    target,
                },
            });
        } else {
            this._router.push(target);
        }
    }
}
